//#region Libraries
import { useState, useEffect } from "react";
//#endregion
//#region Styles
import { Column, Row } from "components/styles";
import { Title, TextData } from "views/components/Schedules/components/UpdateActivityPopup/styles";
//#endregion
//#region Components
import { CustomCheckbox } from "components/CustomCheckbox/CustomCheckbox";
import DialogAlertAction from "components/DialogAlertAction/DialogAlertAction";
import CustomButton from "components/CustomButton/CustomButton";
import Preloader from "components/Preloader/Preloader";
//#endregion
//#region Icons
import CalendarIcon from "icons/CalendarIcon";
import TimerIcon from "icons/TimerIcon";
//#endregion
//#region Services
import { requestSwitchShiftOfSchedule } from "services/appointment/aboutAppoinment";
//#endregion
//#region Utils
import { getText } from "components/CustomTimePicker/utils";
import { getDateMonthString, getDatePartsByMillis, getDayOfDateByTimestamp, getTodayWithoutHourInMillis } from "components/CustomDatePicker/utils/helpers";
import useMainContext from "utils/context/useMainContext";
//#endregion

const getTimeText = hour => {
    return `${getText([hour, 0])} - ${getText([hour + 1, 0])}`;
}
const getDateText = date => {
    const [year, month, dateNumber] = getDatePartsByMillis(date);
    return `${getDayOfDateByTimestamp(date).substring(0, 3)}, ${getDateMonthString([month, dateNumber])} ${year}`;
}

const ManagementAvailability = ({
    dateTimeData: {
        date,
        hour, 
        durationId
    },
    inactivity, showUpdateDialog,
    adviser, reloadData,
    available, changesCannotBeDone 
}) => {
    const mainContext = useMainContext();
    //#region States
    const [activatedHour, setActivatedHour] = useState(null);
    const [showDialogSwitchShiftOfAppointment, setShowDialogSwitchShiftOfAppointment] = useState(false);
    const [loadingSwitchShiftOfAppointment, setLoadingSwitchShiftOfAppointment] = useState(false);
    //#endregion
    useEffect(() => {
        if (!showDialogSwitchShiftOfAppointment)
            setActivatedHour(null);
    }, [showDialogSwitchShiftOfAppointment]);
    //#region Functions
    const changeActivatedHour = () => {
        setActivatedHour(!available);
        setTimeout(() => {
            toggleShowDialogSwitchShiftOfAppointment();
        }, 330);
    }
    const toggleShowDialogSwitchShiftOfAppointment = (value = null) => {
        setShowDialogSwitchShiftOfAppointment(value === null ? !showDialogSwitchShiftOfAppointment : value);
    }
    const getSuccessSwitchMessage = () => {
        const monthDate = getDatePartsByMillis(date).slice(1);
        const todayPrefix = date === -1 || getTodayWithoutHourInMillis() === date ? "Hoy " : "";
        return {
            message: `${todayPrefix}${getDateMonthString(monthDate, 1)} se ha ${activatedHour ? "activado" : "inactivado"} a ${adviser.name} en el horario de ${hour}:00 a ${hour+1}:00`,
            variant: "success",
            milis: 5000
        };
    }
    const switchShiftOfAppointment = async () => {
        setLoadingSwitchShiftOfAppointment(true);
        toggleShowDialogSwitchShiftOfAppointment();
        const success = await requestSwitchShiftOfSchedule(
            activatedHour 
            ? {
                activate: {
                    inactivityId: inactivity.id
                } 
            }
            : {
                inactivate: {
                    durationId,
                    date,
                    timeStart: hour*60
                }
            });
        setLoadingSwitchShiftOfAppointment(false);
        if (!success) {
            mainContext.setShowDialogUnexpectedError(true);
            return;
        }
        await reloadData(getSuccessSwitchMessage());
    }
    const renderDialogButtons = () => {
        return (
            <>
            <CustomButton 
                onClick={() => toggleShowDialogSwitchShiftOfAppointment()}
                variant="quintinary"
                width="130px"
                text="No, cancelar"/>
            <CustomButton 
                onClick={switchShiftOfAppointment}
                width="130px"
                variant="quaternary"
                text={!available ? "Sí, activar" : "Si, inactivar"}/>
            </>
        );
    }
    const dialogSwitchShiftAppointmentProps = {
        show: showDialogSwitchShiftOfAppointment,
        toggleShow: toggleShowDialogSwitchShiftOfAppointment
    };
    //#endregion
    return(
        <>
        <Column width="280px" gap="6px">
            <Title title="">{available ? "Turno disponible" : "Otras actividades"}</Title>
            <Row gap="7px">
                <TimerIcon size={16}/>
                <TextData>{getTimeText(hour)}</TextData>
            </Row>
            <Row gap="7px">
                <CalendarIcon size={16}/>
                <TextData>{getDateText(date)}</TextData>
            </Row>
            <CustomCheckbox
                checked={activatedHour === null ? !available : !activatedHour}
                disabled={changesCannotBeDone()}
                onChange={changeActivatedHour}
                variant="switch"
                padding="28px 0 14px"
                size="small"
                labelColor="var(--light-gray-4)"
                label="Inactivar hora"/>
        </Column>
        <Preloader message="Cambiando turno..." hidden={!loadingSwitchShiftOfAppointment}/>
        {showUpdateDialog && 
            (!available 
            ?  <DialogAlertAction 
                {...dialogSwitchShiftAppointmentProps}
                title="¿Estás seguro(a) de activar esta hora?"
                content="Recuerda que al activar este horario se verá visible para el estudiante y podrá reservar una asesoría">
                {renderDialogButtons()}
            </DialogAlertAction>
            : <DialogAlertAction 
                {...dialogSwitchShiftAppointmentProps}
                title="¿Estás seguro(a) de inactivar esta hora?"
                content="Recuerda que  al inactivar este horario ya no será visible para el estudiante en la app">
                {renderDialogButtons()}
            </DialogAlertAction>)}
        </>
    );
}

export default ManagementAvailability;